import {
  amazonDefaultRegion,
  apiEndpoints
} from "@/components/ExternalApps/SalesChannelManagementApp/utility/amazonRegions";

export const oAuthConfig = [
  {
    name: "amazon",
    config: {
      form: [
        {
          type: "select",
          label: "amazon.region",
          name: "region",
          clearable: true,
          default: amazonDefaultRegion.value,
          options: apiEndpoints,
          validations: {
            required: true
          }
        }
      ],
      params: ["application_id", "redirect_uri"]
    }
  },
  {
    name: "shopify",
    config: {
      form: [],
      params: ["no_redirect", "client_id", "redirect_uri"]
    }
  },
  {
    name: "otto",
    config: {
      form: [],
      params: ["client_id", "response_type", "scope"]
    }
  },
  {
    name: "tiktok",
    config: {
      form: [],
      params: ["service_id"]
    }
  },
  {
    name: "exact",
    config: {
      form: [],
      params: ["client_id", "redirect_uri", "response_type"]
    }
  },
  {
    name: "mollie-pos",
    config: {
      form: [],
      params: [
        "client_id",
        "redirect_uri",
        "response_type",
        "approval_prompt",
        "landing_page",
        "scope"
      ]
    }
  },
  {
    name: "ebay",
    config: {
      form: [],
      params: ["client_id", "redirect_uri", "response_type", "scope", "prompt"]
    }
  },
  {
    name: "woltdelivery",
    config: {
      form: [],
      params: ["client_id", "redirect_url"]
    }
  },
  {
    name: "bexio",
    config: {
      form: [],
      params: ["client_id", "redirect_uri", "response_type", "scope"]
    }
  },
  {
    name: "etsy",
    config: {
      form: [],
      params: []
    }
  }
];
